import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.is-nan.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import TitleCard from 'components/TitleCard';
import FormField, { DefaultFormFieldLayout } from 'components/FormField';
import FormStack from 'components/FormStack';
import { TimeZoneField } from 'components/FormFields';
import DatePicker from 'components/DatePicker';
import TimePicker from 'components/TimePicker';
import TextInput from 'components/TextInput';
import TextArea from 'components/TextArea';
import Box from 'components/Box';
import { getNumberFieldWidth } from 'components/TextInput/utils';
import Hint from 'components/Hint';
import getBasicDate from 'utils/dates/getBasicDate';
import { getSelectedAndTodayDate } from 'utils/timezone';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DetailsCard(_ref) {
  var _fields$capacity$valu;
  var isNested = _ref.isNested,
    fields = _ref.fields;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var startTimeId = 'start-time-field';
  var endTimeId = 'end-time-field';
  var _getSelectedAndTodayD = getSelectedAndTodayDate(fields.date.value, fields.timezone.value),
    selectedDate = _getSelectedAndTodayD.selectedDate,
    zonedTodayDate = _getSelectedAndTodayD.zonedTodayDate;
  return /*#__PURE__*/_jsx(TitleCard, {
    title: t('menu_session_details'),
    variant: "raised",
    headingLevel: isNested ? 'h3' : 'h2',
    children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
      horizontal: true,
      horizontalLabelWidth: 170,
      children: /*#__PURE__*/_jsxs(FormStack, {
        spacing: "m",
        children: [/*#__PURE__*/_jsx(FormField, {
          required: true,
          label: "".concat(t('property_date'), " *"),
          alert: fields.date.error,
          children: /*#__PURE__*/_jsx(DatePicker, {
            dateFormat: "dd/MM/yyyy",
            minDate: zonedTodayDate,
            selected: selectedDate,
            onChange: function onChange(setDate) {
              if (setDate) {
                var scheduledDate = getBasicDate(setDate);
                fields.date.set(scheduledDate);
              }
            }
          })
        }), /*#__PURE__*/_jsx(TimeZoneField, {
          required: true,
          value: fields.timezone.value,
          onChange: function onChange(selectedTimeZone) {
            fields.timezone.set(selectedTimeZone.name);
          }
        }), /*#__PURE__*/_jsx(FormField, {
          required: true,
          label: "".concat(t('property_start_time'), " *"),
          as: "span",
          labelId: startTimeId,
          children: /*#__PURE__*/_jsx(TimePicker, {
            timezone: fields.timezone.value,
            labelledById: startTimeId,
            onChange: function onChange(newValue) {
              return fields.startTime.set(newValue);
            },
            value: fields.startTime.value,
            minuteStep: 1
          })
        }), /*#__PURE__*/_jsx(FormField, {
          required: true,
          label: "".concat(t('property_end_time'), " *"),
          alert: fields.endTime.error,
          as: "span",
          labelId: endTimeId,
          children: /*#__PURE__*/_jsx(TimePicker, {
            timezone: fields.timezone.value,
            labelledById: endTimeId,
            onChange: function onChange(newValue) {
              return fields.endTime.set(newValue);
            },
            value: fields.endTime.value,
            minuteStep: 1
          })
        }), /*#__PURE__*/_jsx(FormField, {
          required: true,
          label: "".concat(t('property_location'), " *"),
          alert: fields.location.error,
          children: /*#__PURE__*/_jsx(TextInput, {
            value: fields.location.value,
            onChange: function onChange(e) {
              return fields.location.set(e.target.value);
            }
          })
        }), /*#__PURE__*/_jsx(FormField, {
          label: t('property_reference'),
          alert: fields.reference.error,
          description: t('hint_admin_use_only'),
          descriptionType: "tooltip",
          children: /*#__PURE__*/_jsx(TextInput, {
            value: fields.reference.value,
            onChange: function onChange(e) {
              return fields.reference.set(e.target.value);
            }
          })
        }), /*#__PURE__*/_jsx(FormField, {
          label: t('form_capacity'),
          description: t('hint_admin_use_only'),
          descriptionType: "tooltip",
          children: /*#__PURE__*/_jsx(Box, {
            width: getNumberFieldWidth(fields.capacity.value || 0),
            children: /*#__PURE__*/_jsx(TextInput, {
              type: "number",
              min: "0",
              value: (_fields$capacity$valu = fields.capacity.value) !== null && _fields$capacity$valu !== void 0 ? _fields$capacity$valu : '',
              onChange: function onChange(e) {
                var parsed = parseInt(e.target.value);
                fields.capacity.set(Number.isNaN(parsed) ? null : parsed);
              }
            })
          })
        }), /*#__PURE__*/_jsx(FormField, {
          label: t('form_meeting_link'),
          alert: fields.linkUrl.error,
          children: /*#__PURE__*/_jsx(TextInput, {
            type: "url",
            value: fields.linkUrl.value,
            onChange: function onChange(e) {
              return fields.linkUrl.set(e.target.value);
            }
          })
        }), /*#__PURE__*/_jsx(FormField, {
          label: t('form_facilitator'),
          children: /*#__PURE__*/_jsx(TextInput, {
            value: fields.facilitator.value,
            onChange: function onChange(e) {
              return fields.facilitator.set(e.target.value);
            }
          })
        }), /*#__PURE__*/_jsx(FormField, {
          label: t('form_joining_instructions'),
          description: /*#__PURE__*/_jsx(Hint, {
            inline: true,
            iconOffset: '-2px',
            children: t('hint_event_session_joining_instructions')
          }),
          children: /*#__PURE__*/_jsx(TextArea, {
            maxRows: 8,
            minRows: 3,
            value: fields.joiningInstructions.value,
            onChange: function onChange(e) {
              return fields.joiningInstructions.set(e.target.value);
            }
          })
        })]
      })
    })
  });
}
export default DetailsCard;